import { hasConfirmationStep } from '~/features/events/lib/address-visibility'
import type { EventEntry } from '~/features/events/lib/event-entry'
import type { EventPrivacy } from '~/features/events/lib/event-privacy'
import * as m from '~/paraglide/messages'
import { SwitchRow } from './setting-row'

type ConfirmationState = { values: { entry?: EventEntry | null; privacy?: EventPrivacy } }

export function AddressHiddenField({
  form,
  savedConfirmation = false,
}: {
  // biome-ignore lint/suspicious/noExplicitAny: TanStack Form API is dynamically typed
  form: any
  savedConfirmation?: boolean
}) {
  return (
    <form.Subscribe
      selector={(state: ConfirmationState) => hasConfirmationStep(state.values, savedConfirmation)}
    >
      {(confirmed: boolean) =>
        confirmed ? (
          <form.Field name="addressHidden">
            {/* biome-ignore lint/suspicious/noExplicitAny: TanStack Form field API */}
            {(field: any) => (
              <SwitchRow
                id={field.name}
                className="border-t pt-4 pb-0"
                label={m.addressHiddenLabel()}
                hint={m.addressHiddenHint()}
                checked={field.state.value === true}
                onCheckedChange={(checked) => field.handleChange(checked)}
              />
            )}
          </form.Field>
        ) : null
      }
    </form.Subscribe>
  )
}
